import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import Budget from '../../../widgets/budget/Budget'
import { useParams, useHistory } from 'react-router-dom'
import { getPaymentCheck, savePaymentCheckForceCommit } from '../../../redux/actions/paymentCheck'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import pathname from '../../../constants/pathname'
//ขั้นที่ 1 ตรวจสอบงวดเงิน
export default function PaymentCheck() {
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [confirmForceSchema, setConfirmForceSchema] = useState()

  // const proposalId = '1D3684B7-4D9D-4DED-AE29-DEC6C214B8EC'

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getPaymentCheck(proposalId)
      setSchema(_schema)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleConfirmBudget = async (
    _setIsLoading,
    _setErrorMessage,
    _setIsShowConfirmForce,
    forceCommit = false
  ) => {
    startLoading()
    _setIsLoading(true)
    _setErrorMessage()
    try {
      var response = await savePaymentCheckForceCommit(projectId, forceCommit)
      if (response.isSuccess) {
        doneLoading()
        return history.push(`${pathname.proposal.approve.granteeForStaff}?2`)
      } else if (!response.isSuccess && response.confirm) {
        setConfirmForceSchema(response.confirm)
        _setIsShowConfirmForce(true)
        _setErrorMessage(response?.message)
      } else {
        _setErrorMessage(response?.message)
      }
    } catch (e) {
      console.log(e)
      _setErrorMessage(
        e.response?.data?.errorMessage ||
          'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
      )
    }
    _setIsLoading(false)
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <ProjectBasicInfo schema={schema?.forms?.projectInfo} />

          <br />

          <Budget
            schema={schema?.forms}
            isEditable={false}
            defaultExpandAllRows={true}
            isShowBudgetSubmitButton={true}
            onClickConfirmBudget={handleConfirmBudget}
            confirmForceSchema={confirmForceSchema}
          />
          <br />
        </SidebarProposal>
      )}
    </>
  )
}
